import {useEffect, useState} from "react";
import valuation_api from "../api/valuation";


const TransferringValuationModal = (props) => {

    const valuation = props.valuation
    const setValuation = props.setValuation
    const setShowErrorDialog = props.setShowErrorDialog
    const setError = props.setError
    const updateAfterTransfer = props.updateAfterTransfer

    const [teamMembers, setTeamMembers] = useState([])
    const [newClient, setNewClient] = useState()
    const [transferring, setTransferring] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        getOrganisationMembers()
    }, []);

    const getOrganisationMembers = () => {
        let response = valuation_api.getOrganisationMembers();
        response.then(
            response => {
                setTeamMembers(response.data.organisation_members);
            }
        ).catch(err => {
            setError("Failed to retrieve team members")
            setValuation(false)
            setShowErrorDialog(true)
        })
    }

    const handleTransferValuation = () => {
        if (!valuation || !newClient) {
            setError("Failed to transfer valuation")
            setValuation(false)
            setShowErrorDialog(true)
            return
        }
        setTransferring(true)
        let response = valuation_api.transferValuation(valuation.id, newClient);
        response.then(
            response => {
                if (response.data.status && response.data.status === "Success") setSuccess(true)
                else {
                    setError("Failed to transfer valuation")
                    setTransferring(false)
                    setValuation(false)
                    setShowErrorDialog(true)
                }
            }
        ).catch(err => {
            setError("Failed to transfer valuation")
            setTransferring(false)
            setValuation(false)
            setShowErrorDialog(true)
        })
    }

    return (
        <>
            <div className="page-mask low" onClick={() => setValuation(false)}/>
            {transferring && transferring
                ?
                <div className="transfer-dialog-container">
                    {success && success
                        ?
                        <>
                            <div className="transfer-close-button link" onClick={() => updateAfterTransfer()}>x</div>
                            <div className="transfer-dialog-title center">The selected case has been successfully transferred</div>
                        </>
                        :
                        <>
                            <div className="button-loading-wheel-container">
                                <div className="loading-wheel-center"/>
                            </div>
                        </>
                    }
                </div>
                :
                <div className="transfer-dialog-container">
                    <div className="transfer-dialog-title">Transfer case</div>
                    <div className="transfer-dialog-description">Send this case to another team member</div>
                    <div className="transfer-dialog-fields-container">
                        <div className="transfer-dialog-field-container">
                            <div className="transfer-dialog-field">Address:</div>
                            <div className="transfer-dialog-value">{valuation && valuation.address}</div>
                        </div>
                        <div className="transfer-dialog-field-container">
                            <div className="transfer-dialog-field">Status:</div>
                            <div className="transfer-dialog-value">{valuation && valuation.summary_status_name}</div>
                        </div>
                    </div>
                    <div className="transfer-dialog-value">Team member</div>
                    <div className="transfer-dialog-dropdown">
                        <select value={newClient} onChange={(ev) => setNewClient(ev.target.value)}>
                            <option value={null} selected disabled>Select team member</option>
                            {teamMembers && teamMembers.map((client, idx) => {
                                return (
                                    <option value={client.email}>{client.firstname} {client.lastname}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="transfer-dialog-description">
                        Note: Once reassigned, this report will be removed from your My Reports list, and move to the
                        selected team member’s My Reports list.
                    </div>
                    <div className="transfer-dialog-footer-container">
                        <div className="transfer-dialog-button cancel link" onClick={() => setValuation(false)}>
                            <div className="dialog-button-text">Cancel</div>
                        </div>
                        <div className={newClient ? "transfer-dialog-button link" : "transfer-dialog-button disabled"} onClick={() => handleTransferValuation()}>
                            <div className="dialog-button-text">Transfer</div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default TransferringValuationModal